import React from 'react'
import PropTypes from 'prop-types'
import { loadCollectionRouteAction } from 'modules/routes/actions'
import { isDifferentLocationUtil } from 'modules/router/utils'

const loadCollection = (Component) => {
  const LoadCollection = (props) => {
    const prevLocationRef = React.useRef()

    const loadData = (propsToUse = props) => {
      propsToUse.dispatch(
        loadCollectionRouteAction({
          route: propsToUse.route,
          match: propsToUse.match,
          options: {
            location: propsToUse.location
          }
        })
      )
    }

    // Effect for initial load (equivalent to componentDidMount)
    React.useEffect(() => {
      loadData()
    }, []) // Empty dependency array means this runs once on mount

    // Effect for updates (equivalent to componentDidUpdate)
    React.useEffect(() => {
      if (
        prevLocationRef.current &&
        isDifferentLocationUtil(prevLocationRef.current, props.location) &&
        props.route.isCollection
      ) {
        loadData(props)
      }
      prevLocationRef.current = props.location
    }, [
      props.location,
      props.route
    ])

    return <Component {...props} />
  }

  LoadCollection.propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object,
    route: PropTypes.object.isRequired
  }

  LoadCollection.displayName = `LoadCollection(${Component.displayName || Component.name})`

  return LoadCollection
}

export default loadCollection
